export const DsfSuperSearch = Vue.defineAsyncComponent(() =>
  import(/* webpackChunkName: "platform_pc_supersearch" */ "./superSearch.vue")
);
export const DsfSuperSearchFilter = Vue.defineAsyncComponent(() =>
  import(/* webpackChunkName: "platform_pc_supersearch" */ "./superSearchFilter.vue")
);
export const DsfSuperSearchItem = Vue.defineAsyncComponent(() =>
  import(/* webpackChunkName: "platform_pc_supersearch" */ "./superSearchItem.vue")
);
export const DsfSuperSearchInput = Vue.defineAsyncComponent(() =>
  import(/* webpackChunkName: "platform_pc_supersearch" */ "./superSearchInput.vue")
);
export const DsfSuperSearchNumber = Vue.defineAsyncComponent(() =>
  import(/* webpackChunkName: "platform_pc_supersearch" */ "./superSearchNumber.vue")
);
export const DsfSuperSearchSelect = Vue.defineAsyncComponent(() =>
  import(/* webpackChunkName: "platform_pc_supersearch" */ "./superSearchSelect.vue")
);
export const DsfSuperSearchTreeSelect = Vue.defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "platform_pc_supersearch" */ "./superSearchTreeSelect.vue"
  )
);
export const DsfSuperSearchDataPicker = Vue.defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "platform_pc_supersearch" */ "./superSearchDataPicker.vue"
  )
);
export const DsfSuperSearchPeriod = Vue.defineAsyncComponent(() =>
  import(/* webpackChunkName: "platform_pc_supersearch" */ "./superSearchPeriod.vue")
);
export const DsfSuperSearchDataChoice = Vue.defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "platform_pc_supersearch" */ "./superSearchDataChoice.vue"
  )
);
